 export enum AffichagePlanningUtilisateurEnum {
Aucun = 0,
VueValideur = 1,
VueTousLesSalaries = 2,
VueRegroupementSociete = 3,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/AffichagePlanningUtilisateurEnum.ts